// extracted by mini-css-extract-plugin
export var addToCart = "style-mod--add-to-cart--1e2df";
export var added = "style-mod--added--ae253";
export var badge = "style-mod--badge--5d634";
export var body = "style-mod--body--56fba";
export var bodyWrapper = "style-mod--body-wrapper--93677";
export var cart = "style-mod--cart--3e6ca";
export var cartInfo = "style-mod--cart-info--d4c6b";
export var checkoutButton = "style-mod--checkout-button--16eda";
export var checkoutButtonFill = "style-mod--checkout-button-fill--ec828";
export var chefSnippet = "style-mod--chef-snippet--81f86";
export var closeIcon = "style-mod--close-icon--d3583";
export var comparePrice = "style-mod--compare-price--29128";
export var dec = "style-mod--dec--4ee07";
export var description = "style-mod--description--1222a";
export var details = "style-mod--details--b39d0";
export var discount = "style-mod--discount--abd15";
export var discountBox = "style-mod--discount-box--2d294";
export var discountBtn = "style-mod--discount-btn--0a73b";
export var discountContainer = "style-mod--discount-container--45e96";
export var discountInfos = "style-mod--discount-infos--60669";
export var discountInput = "style-mod--discount-input--d1d76";
export var discountLoader = "style-mod--discount-loader--99b40";
export var discountTotal = "style-mod--discount-total--bcd02";
export var discountWrapper = "style-mod--discount-wrapper--2d7d2";
export var discountedPrice = "style-mod--discounted-price--5b0a4";
export var empty = "style-mod--empty--a4d20";
export var emptyImage = "style-mod--empty-image--9ad3d";
export var errorDiscount = "style-mod--error-discount--bbc6a";
export var header = "style-mod--header--4be43";
export var highlightText = "style-mod--highlight-text--8ee52";
export var icon = "style-mod--icon--2e2a1";
export var image = "style-mod--image--987fc";
export var imageWrapper = "style-mod--image-wrapper--205be";
export var inMobile = "style-mod--in-mobile--5f830";
export var inc = "style-mod--inc--9030c";
export var increment = "style-mod--increment--b1fd7";
export var item = "style-mod--item--bafa1";
export var items = "style-mod--items--cd8db";
export var loaderKeyFrames = "style-mod--loader-key-frames--756a4";
export var message = "style-mod--message--ffd47";
export var messageDesc = "style-mod--message-desc--14524";
export var messageDiscount = "style-mod--message-discount--dbb7e";
export var name = "style-mod--name--b64b1";
export var offerInfo = "style-mod--offer-info--cf0e3";
export var offerMessage = "style-mod--offer-message--01522";
export var opened = "style-mod--opened--00947";
export var price = "style-mod--price--43183";
export var priceWrapper = "style-mod--price-wrapper--9ca2f";
export var pricesBox = "style-mod--prices-box--ffd75";
export var qtyCompPrices = "style-mod--qty-comp-prices--d191a";
export var qtyDiscountPrice = "style-mod--qty-discount-price--07141";
export var qtyPrice = "style-mod--qty-price--9f8de";
export var qtyPrices = "style-mod--qty-prices--ec6d7";
export var recommendation = "style-mod--recommendation--5854b";
export var recommendations = "style-mod--recommendations--3780e";
export var reducePanelWidth = "style-mod--reduce-panel-width--d2542";
export var removeDiscountX = "style-mod--remove-discount-x--ebc97";
export var removeIcon = "style-mod--remove-icon--a3f57";
export var saved = "style-mod--saved--8aa68";
export var savedAmount = "style-mod--saved-amount--e163f";
export var scroll = "style-mod--scroll--053b3";
export var shipping = "style-mod--shipping--28163";
export var shortDesc = "style-mod--short-desc--ad514";
export var snippetAndCta = "style-mod--snippet-and-cta--98a71";
export var subtitle = "style-mod--subtitle--3cf8f";
export var sum = "style-mod--sum--1dd4e";
export var title = "style-mod--title--8116d";
export var total = "style-mod--total--0294c";
export var totalMessage = "style-mod--total-message--190d6";
export var totalSum = "style-mod--total-sum--3d9ff";
export var totality = "style-mod--totality--292bb";
export var val = "style-mod--val--6028a";